import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../services/config';
import { WrapperHttpService } from '../../../services/wrapper-http-service';
import { Base } from '../../../../common/models';
import { AddressEndpoint } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class AddressPlantGateListService {
  constructor(private http: WrapperHttpService) {}

  getList(): Observable<Base[]> {
    const url = `${API_URL}${AddressEndpoint.Base}${AddressEndpoint.Gates}`;

    return this.http.withLoading().get<Base[]>(url);
  }
}
